<template>
    <slot :file="file" :change="change">
        <input ref="csvRef" type="file" @change="change" :name="name" v-bind="$attrs">
    </slot>
</template>

<script>
    import {inject, ref, watch} from 'vue';
    import get from 'lodash/get';
    import merge from 'lodash/merge';
    import Papa from "papaparse";
    import guessMimeType from "../util/mimeDictionary";

    /* eslint-disable */
    export default {
        name: "BstkCsvFile",
        props: {
            name: {
                type: String,
                default: 'csv'
            },
            headers: {
                type: [Boolean, null],
                default: true
            },
            create: {
                type: [Boolean, null],
                default: false
            },
            parseConfig: {
                type: Object,
                default: () => {
                    return {};
                }
            },
            validation: {
                type: Boolean,
                default: true,
            },
            fileMimeTypes: {
                type: Array,
                default: () => {
                    return ["text/csv", "text/x-csv", "application/vnd.ms-excel", "text/plain"];
                }
            }
        },
        setup(props) {
            const csvRef = ref(null);
            const BstkCSVImportData = inject('BstkCSVImportData');
            const buildMappedCsv = inject('buildMappedCsv');
            const labels = BstkCSVImportData.language;

            BstkCSVImportData.inputName = name;
            BstkCSVImportData.fileHasHeaders = props.headers !== null ? !!props.headers : null;
            BstkCSVImportData.addNewRecords = props.create !== null ? !!props.create : null;

            const validate = function (file) {
                BstkCSVImportData.errors = [];

                if (!file) {
                    BstkCSVImportData.errors.push(labels.errors.fileRequired);
                }

                if (props.validation) {
                    const mimeType = file.type === "" ? guessMimeType(file.name) : file.type;

                    if (!props.fileMimeTypes.includes(mimeType)) {
                        BstkCSVImportData.errors.push(labels.errors.invalidMimeType);
                    }

                    return BstkCSVImportData.errors.length === 0;
                }

                return true;
            }

            const change = function () {
                let tmpFile = csvRef.value.files ? csvRef.value.files[0] : null;

                if (validate(tmpFile)) {
                    BstkCSVImportData.file = tmpFile;
                }
            }

            watch(() => BstkCSVImportData.file, newCurrentFile => {
                if (!newCurrentFile) {
                    BstkCSVImportData.csvSample.value = null;
                    BstkCSVImportData.rawCsv.value = null;
                }
                let reader = new FileReader();
                reader.readAsText(BstkCSVImportData.file, "UTF-8");
                reader.onload = function (evt) {
                    BstkCSVImportData.csvSample = get(Papa.parse(evt.target.result, merge({
                        preview: 2,
                        skipEmptyLines: true
                    }, props.parseConfig)), "data");
                    BstkCSVImportData.rawCsv = get(Papa.parse(evt.target.result, merge({skipEmptyLines: true}, props.parseConfig)), "data");
                };
                reader.onerror = function (err) {
                    console.log(err);
                };
            }, {deep: true});

            watch(() => BstkCSVImportData.fileHasHeaders, () => {
                if (BstkCSVImportData.allFieldsAreMapped) {
                    buildMappedCsv();
                }
            });

            watch(() => BstkCSVImportData.addNewRecords, () => {
                if (BstkCSVImportData.allFieldsAreMapped) {
                    buildMappedCsv();
                }
            });

            return {
                file: BstkCSVImportData.file,
                change,
                csvRef
            }
        },
    };
</script>